import { mapState } from 'vuex';

import { wrapToLoadingFn } from '@helpers';
import { LOCATIONS_NAMESPACE } from '@store/modules/locations.types';

import { getLocationNameBySuffix } from '../../_utils';

import { AddedDependenciesList, DependencyAdder } from './_components';
import {
  LOADING_FLAG_NAME,
  DEPENDENCY_NAME,
  DEPENDENCY_TYPE,
  DATA_PROP_NAME,
  LOADING_FLAGS,
  REQUEST,
  PROPS,
} from './constants';

export default {
  name: 'OperatorDependenciesEditor',

  props: PROPS,

  components: {
    AddedDependenciesList,
    DependencyAdder,
  },

  data() {
    return {
      addedMachine: '',
      addedLocation: '',

      dialog: false,

      DEPENDENCY_TYPE,
      ...LOADING_FLAGS,
    };
  },

  computed: {
    ...mapState('machines', {
      machineSelectOptions({ machines }) {
        return machines
          .filter(({ name }) => !this.machines.includes(name))
          .map(({ name }) => ({ value: name, text: name }));
      },
    }),

    ...mapState(LOCATIONS_NAMESPACE, {
      suffix: ({ suffix }) => suffix,
      allLocations: ({ locations }) => locations,
      locationSelectOptions({ locations }) {
        return locations
          .filter(({ suffix }) => !this.locations.includes(suffix))
          .map(({ name, suffix }) => ({ value: suffix, text: name }));
      },
    }),

    title() {
      return `${this.operatorName} dependencies`;
    },
  },

  methods: {
    addDependency(type, data) {
      const [addRequest] = REQUEST[type];
      const [loadingFlagName] = LOADING_FLAG_NAME[type];

      this.wrapToLoadingFn({
        req: addRequest.bind(null, {
          operatorId: this.operatorId,
          suffix: this.suffix,
          data,
        }),
        loadingFlagName,
        onSuccess: () => {
          this.$VBlackerTheme.notification.success(`${DEPENDENCY_NAME[type]} successfully added`);
          this[DATA_PROP_NAME[type]] = '';
          this.$emit('success');
        },
      });
    },

    removeDependency(type, data) {
      const [, removeRequest] = REQUEST[type];
      const [, loadingFlagName] = LOADING_FLAG_NAME[type];

      this.wrapToLoadingFn({
        req: removeRequest.bind(null, {
          operatorId: this.operatorId,
          suffix: this.suffix,
          data,
        }),
        loadingFlagName,
        onSuccess: () => {
          this.$VBlackerTheme.notification.success(`${DEPENDENCY_NAME[type]} successfully removed`);
          this[DATA_PROP_NAME[type]] = '';
          this.$emit('success');
        },
      });
    },

    resetForm() {
      this.addedMachine = '';
      this.addedLocation = '';
    },

    getLocationNameBySuffix(suffix) {
      return getLocationNameBySuffix(suffix, this.allLocations);
    },

    wrapToLoadingFn,
  },
};
